module.exports = __webpack_public_path__ + "img/full7-min.f1be11f3.png";